import { ConcreteEncodable } from "./ConcreteEncodable";

import { AdminModelUploadImplEncoder } from "../../encoder/AdminModelUploadImplEncoder";

import * as CubiqTS from "../../index";
import { AdminModelUpload } from "../AdminModelUpload";

export class AdminModelUploadImpl extends ConcreteEncodable implements AdminModelUpload {
  public static enType: string = "com.bcdfx.model.event.admin.AdminModelUploadImpl";

  /*FID=1*/
  public id: string;
  /*FID=2*/
  public operationType: CubiqTS.AdminModelOperationType;
  /*FID=3*/
  public payload: string;
  /*FID=100*/
  public messageId: string;
  /*FID=10010*/
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = AdminModelUploadImplEncoder.Instance;
    this.setEncodableType(AdminModelUploadImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "AdminModelUploadImpl[" +
      "id=" +
      this.id +
      "operationType=" +
      this.operationType +
      "payload=" +
      this.payload +
      "messageId=" +
      this.messageId +
      "sessionOnly=" +
      this.sessionOnly +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
